import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const alonTrades: SeasonTrades[] = [
  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Andrew Wiggins and Markieff Morris",
        gotInReturn: "Nikola Vucevic and Isaiah Thomas",
        amongBestTrades: true
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Reggie Jackson",
        gotInReturn: "Kyle Lowry",
        amongBestTrades: true
      },
    ],
  },
  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Stanley Johnson",
        gotInReturn: "DeAndre Jordan",
        amongBestTrades: true
      },
    ],
  },
];